<template lang="html">
  <div id="SelectHeaderDialog">
    <vs-popup class="holamundo" title="컬럼을 선택해주세요!" :active.sync="dialogVisible">
      <el-row class="select-wrapper" :gutter="20">
        <label class="select-label" for="address">*주소 (필수)</label>
        <select id="address" placeholder="주소 컬럼을 선택해주세요.'" v-model="selected.address">
          <option value="">주소 컬럼을 선택해주세요.</option>
          <option v-for="(header, index) in headers" v-if="!header.toLowerCase().includes('unknown')" :key="index">{{ header }}</option>
        </select>
      </el-row>
      <el-row class="select-wrapper" :gutter="20">
        <label class="select-label" for="address">*목적지 (필수)</label>
        <select placeholder="목적지 컬럼을 선택해주세요.'" v-model="selected.name">
          <option value="">목적지 컬럼을 선택해주세요.</option>
          <option v-for="(header, index) in headers" v-if="!header.toLowerCase().includes('unknown')" :key="index">{{ header }}</option>
        </select>
      </el-row>
      <el-row class="select-wrapper" :gutter="20">
        <label class="select-label" for="address">연락처</label>
        <select placeholder="연락처 컬럼을 선택해주세요.'" v-model="selected.phone">
          <option value="">연락처 컬럼을 선택해주세요.</option>
          <option v-for="(header, index) in headers" v-if="!header.toLowerCase().includes('unknown')" :key="index">{{ header }}</option>
        </select>
      </el-row>
      <el-row :span="24" style="margin: 16px 8px;">
        <hr style="color: var(--gray-color);">
      </el-row>
      <el-row :span="24" class="gm-layout-horizontal" style="margin-top: 12px;">
        <el-button size="small" @click="cancel" style="width: 80px; margin-left: auto; margin-right: 8px;">취소</el-button>
        <el-button size="small" type="primary" style="width: 80px; margin-right: 8px;" @click="complete" :disabled="!completable">선택완료</el-button>
      </el-row>
    </vs-popup>
  </div>
</template>
<script>
export default {
  name: 'SelectHeaderDialog',
  props: {
    headers: Array,
    onSuccess: Function
  },
  components: {},
  data: () => ({
    dialogVisible: false,
    label: ['주소', '목적지 명', '연락처'],
    selected: {
      address: '',
      name: '',
      phone: ''
    }
  }),
  beforeDestroy() {
    this.$event.$off([
      this.$eventList.showSelectHeaderDialog
    ])
  },
  methods: {
    complete() {
      let selectedHeaders = []
      let props = ['address', 'name', 'phone']
      for (let i in Object.values(this.selected)) {
        if (this.selected[props[i]] !== '') {
          selectedHeaders.push({
            'label': this.selected[props[i]], // 사용자가 선택한 컬럼
            'prop': props[i] // 내부에서 사용하는 명칭
          })
        }
      }
      this.onSuccess(selectedHeaders)
      this.dialogVisible = false
    },
    cancel() {
      this.dialogVisible = false
    }
  },
  mounted() {
    this.$event.$on(this.$eventList.showSelectHeaderDialog, isShow => {
      this.dialogVisible = isShow
      // 초기화
      this.selected = {
        address: '',
        name: '',
        phone: ''
      }
    })
  },
  computed: {
    completable: function() {
      return (this.selected.address !== '' && this.selected.name !== '')
    }
  }
}

</script>
<style lang="scss" scoped>
#SelectHeaderDialog {}

.select-wrapper {
  display: flex;
  margin: 16px;
  flex-direction: column;

  .select-label {
    height: 20px;
    width: 230px;
    margin: auto;
    font-size: 14px;
  }

  select {
    height: 30px;
    margin: auto;
    background-color: white;
    width: 220px !important;
    padding: 4px;
    border: 1px solid var(--font-color);
    background: url("data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' width='100' height='100' fill='black'><polygon points='0,30 100,30 50,80'/></svg>") no-repeat;
    background-size: 12px;
    background-position: calc(100% - 5px) center;
    background-repeat: no-repeat;
    background-color: white;
    -webkit-appearance: none;
    -moz-appearance: none;
    appearance: none;
  }

  option {
    background-color: white;
  }
}

</style>



// WEBPACK FOOTER //
// src/components/Create/SelectHeaderDialog/index.vue